import {
  BaseCellRenderer,
  createFromBaseCellRenderer,
  createIcon,
} from '@blocksuite/data-view';
import { css } from '@emotion/css';
import { html } from 'lit';

import { rowNumberPropertyModelConfig } from './define.js';

const rowNumberCellStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  userSelect: 'none',
});

const textStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 'var(--data-view-cell-text-line-height)',
  color: 'var(--affine-text-secondary-color)',
  fontSize: '14px',
});

/**
 * Displays the 1-based index of the row in the current view.
 * The value is computed from the view's row order and cannot be edited.
 */
export class RowNumberCell extends BaseCellRenderer<number, number> {
  override connectedCallback(): void {
    super.connectedCallback();
    this.classList.add(rowNumberCellStyle);
  }

  override beforeEnterEditMode() {
    return false;
  }

  get rowNumber() {
    const index = this.row?.index$.value;
    return index == null ? null : index + 1;
  }

  protected override render() {
    return html`<div class="${textStyle}" data-testid="row-number-cell">
      ${this.rowNumber ?? ''}
    </div>`;
  }
}

export const rowNumberColumnConfig =
  rowNumberPropertyModelConfig.createPropertyMeta({
    icon: createIcon('NumberedListIcon'),
    cellRenderer: {
      view: createFromBaseCellRenderer(RowNumberCell),
    },
  });
